import { useState } from "react";
import {
  IconButton,
  Popover,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import { Info } from "@mui/icons-material";
import FormulaBrokerage from "../FormulaBrokerage";
import FormulaFinalRate from "../FormulaFinalRate";
import FormulaCD from "../FormulaCD";

const BillInfo = ({ data }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "formula-popover" : undefined;

  const unit = data.po_unit || "";
  const attachUnit = (w) => `${w} ${unit}`;

  const details = [
    {
      label: "Bill Rate",
      value: `₹ ${Number(data.bill_rate ?? 0).toFixed(0)}/-`,
    },
    {
      label: "Brokerage (Amount for Miller)",
      value:   <FormulaBrokerage final_weight={data.final_weight} miller={true}/>,
    },{
      label: "Brokerage (Amount for Broker)",
      value:   <FormulaBrokerage final_weight={data.final_weight} broker={true}/>,
    },
    {
      label: "Discount Amt (CD)",
      value: (
        <Typography fontSize="0.775rem">
        <FormulaCD 
            billRate={data.bill_rate}
            cashDiscount={data.cash_discount}/>
        </Typography>
      ),
    },
    {
      label: "Final Rate",
      value: (
        <Box sx={{display:"flex",flexDirection:"row",alignItems:"center"}}>
          <Typography  sx={{display:"flex",alignItems:"center"}} fontSize="0.775rem">
            ₹ {Number(data.final_rate ?? 0).toFixed(0)}/-
          </Typography>
          <FormulaFinalRate
            billRate={data.bill_rate}
            cashDiscount={data.cash_discount}
            discountAmount={data.miller_discounted_amount}
            finalRate={data.final_rate}
          />
        </Box>
      ),
    },
  ];

  return (
    <>
      <Box display="flex" alignItems="center">
        <Typography
                onClick={handleOpen}
                 fontSize="0.775rem"
                 sx={{
                   textDecoration: "underline",
                   textUnderlineOffset: "4px",
                   cursor: "pointer",
                 }}>
          {`₹ ${Number(data.final_rate ?? 0).toFixed(0)}/-`}
        </Typography>
      
      </Box>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            minWidth: "250px",
          }}
        ><Typography fontSize="0.8rem" fontWeight="bold" mb={1}>
                    Rate Details
                  </Typography>
          {details.map((item, index) => (
            <Box key={index} mb={index < details.length - 1 ? 1.5 : 0}>
              <Typography
                fontSize="0.775rem"
                display="flex"
                justifyContent="space-between"
              >
                <span style={{ color: "#6b7280",marginRight:"5px" }}>{item.label}:</span>
                <span>{item.value}</span>
              </Typography>
              {index < details.length - 1 && <Divider sx={{ my: 1 }} />}
            </Box>
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default BillInfo;
